import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {AngularFireAuth} from '@angular/fire/auth';
import {Router} from '@angular/router';
import {MainFeedComponent} from '../main-feed/main-feed.component';
import * as firebase from 'firebase';
import {AngularFireList, AngularFireDatabase} from '@angular/fire/database';
import {User} from '../models/user';
import {FirebaseListObservable} from '@angular/fire/database-deprecated';


@Injectable({
  providedIn: 'root'
})
export class AuthServiceService {


  userData: Observable<firebase.User>;
  users$: AngularFireList<User>;

  users: FirebaseListObservable<User[]> = null;

  thisUser = {
    displayName: '',
  email: '',
  password: '',
  country: '',
  uid: ''
  }

  u = {} as User;



  constructor(private angularFireAuth: AngularFireAuth, public router: Router) {
    this.userData = angularFireAuth.authState;
  }

  /* Sign up */
  SignUp(email: string, password: string) {
    this.angularFireAuth
      .auth
      .createUserWithEmailAndPassword(email, password)
      .then(res => {
        console.log('Successfully signed up!', res);
      })
      .catch(error => {
        console.log('Something is wrong:', error.message);
      });
  }

  addUser(newUser: User): void {
    this.users.push(newUser);
  }

  /* Sign in */
  SignIn(email: string, password: string) {
    this.angularFireAuth
      .auth
      .signInWithEmailAndPassword(email, password)
      .then(res => {
        this.router.navigate(['mainFeed']);
      })
      .catch(err => {
        console.log('Something is wrong:', err.message);
      });
  }

  /* Sign out */
  SignOut() {
    this.angularFireAuth.auth.signOut();
    this.router.navigate(['Home']);
  }

}
